import { render, staticRenderFns } from "./FruitCollection.vue?vue&type=template&id=6c064591&"
import script from "./FruitCollection.vue?vue&type=script&lang=js&"
export * from "./FruitCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports